import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { storeMotorista, loadMotoristas } from '~/store/modules/motorista/action';
import { loadPotencialPoluidores } from '~/store/modules/potencial_poluidor/action';
import removeMask from '~/utils/removeMask';

const Create = ({entidade_id}) => {
  let history = useHistory();
  const [motorista, setMotorista] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ MotoristaReducer }) => MotoristaReducer);

  useEffect(() => {
    dispatch(loadPotencialPoluidores());
  }, [dispatch]);

  useEffect(() => {
    // console.log('errors create motorista: ',errors);
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.save) {
      setSaved(errors.save);
    }
  }, [errors]);

  useEffect(() => {
    // console.log('Sucesso create motorista: ',status_response);
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadMotoristas({
            where:`entidade_id:${entidade_id}`
          }));
        }
      );
    }
  }, [status_response, history, dispatch, saved, entidade_id]);

  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setErrorsValidate([]);
    // console.log('motorista store: ',motorista);
    if (!schema.isValidSync(motorista)) {
      let yup_errors = {};
      schema.validate(motorista, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const motori = motorista;
      motori.potencial_poluidor_id = parseInt(motori.potencial_poluidor_id);
      motori.entidade_id = parseInt(entidade_id);
      motori.cpf = removeMask(motori.cpf)
      // console.log('motorista store: ',motori);
      await dispatch(storeMotorista(motori));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Motorista
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              motorista={motorista}
              schema={schema}
              setMotorista={setMotorista}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_motorista"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
